import { Component, Input, Output, EventEmitter, AfterViewInit, OnInit, Renderer2 } from '@angular/core';
import { FieldValue } from '../../../../../@core/models/site-material-data.model';

@Component({
    selector: 'app-material-input',
    templateUrl: './input.component.html',
    styleUrls: ['./input.component.scss']
})

export class MaterialInputComponent {
    @Input() positionField: number = undefined;
    @Input() field: number = undefined;
    @Input() formInfos: { type: string; name: string; placeholder: string; required: boolean; requiredAlertMessage: string; };
    @Output() setValueEvent = new EventEmitter<FieldValue>();
    value: string = '';
    errorMessage: string = '';
    constructor() { }
    inputValidator(value: string) {
        if (this.formInfos.type === 'email') {
            // tslint:disable-next-line:max-line-length
            const regex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            const email = regex.test(String(this.value).toLowerCase());
            if (email) {
                this.errorMessage = '';
                this.setValueEvent.emit({ type: 'email', value: this.value, required: this.formInfos.required, position: this.field });
            } else {
                this.errorMessage = 'Please choose a valid email';
                this.setValueEvent.emit({ type: 'email', value: this.value, required: this.formInfos.required, position: this.field });
            }
        } else if (this.formInfos.type === 'phone') {
            if (this.value.match(/^\d{10}$/g)) {
                this.errorMessage = '';
                this.setValueEvent.emit({ type: 'phone', value: this.value, required: this.formInfos.required, position: this.field });
            } else {
                this.errorMessage = 'Please choose a valid phone number';
                this.setValueEvent.emit({ type: 'phone', value: this.value, required: this.formInfos.required, position: this.field });
            }
        } else {
            const regex = new RegExp('^[a-zA-Z10-9 ,]+$');
            const text = regex.test(this.value);
            if (text) {
                this.errorMessage = '';
                this.setValueEvent.emit({ type: 'text', value: this.value, required: this.formInfos.required, position: this.field });
            } else {
                this.errorMessage = this.formInfos.name + ' is not valid';
                this.setValueEvent.emit({ type: 'text', value: this.value, required: this.formInfos.required, position: this.field });
            }
        }
    }
}
